angular
  .module('surfsightApp.controllers')
  .controller('ChangePasswordController', [
    '$scope',
    '$http',
    '$localStorage',
    '$mdDialog',
    '$mdToast',
    '$filter',
    function ($scope, $http, $localStorage, $mdDialog, $mdToast, $filter) {
      var $translate = $filter('translate')
      $scope.changePassword_data = {}
      $scope.checkMatchingpassword = function (form) {
        if (form.newPassword1.$modelValue && form.newPassword1.$modelValue) {
          if (form.newPassword1.$modelValue != form.newPassword2.$modelValue) {
            form.newPassword2.$setValidity('retypeMismatch', false)
            return true
          } else {
            form.newPassword2.$setValidity('retypeMismatch', true)
          }
        }
        return false
      }
      $scope.changePassword = function (form) {
        if ($scope.checkMatchingpassword(form)) {
          $scope.showMessageToast('Confirm password not matching')
          return false
        }
        var request_json = {
          method: 'POST',
          url:
            USER_BASEURL +
            '/users/' +
            $localStorage.userDetails.id +
            '/changePassword',
          data: $scope.changePassword_data
        }
        $http(request_json).then(
          function (response) {
            if (response.data.status.code == 0) {
              $mdDialog.hide(response)
            } else {
              $scope.showMessageToast($translate(response.data.status.error))
            }
          },
          function (response) {
            if (response && response.data) {
              if (response.data.statusCode == 401) {
                $state.go('home.login')
              }
            } else {
              alert('Error occurred.')
            }
          }
        )
      }
      $scope.cancel = function () {
        $mdDialog.cancel()
      }

      $scope.showMessageToast = function (message) {
        var toast = $mdToast
          .simple()
          .textContent(message)
          .action($translate('ok'))
          .position('bottom')
          .hideDelay(5000)
          .actionKey('F1')
          .parent('#change-passsword-container')

        $mdToast
          .show(toast)
          .then(function (response) {})
          .catch(() => {})
      }
    }
  ])
